__turbopack_context__.v({
  "className": "polysans_1237fc34-module__-Zcosa__className",
  "variable": "polysans_1237fc34-module__-Zcosa__variable",
});
